(function (factory) {
  /* global define */
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(window.jQuery);
  }
}(function ($)
{
	$.extend($.summernote.plugins,
	{
		mediabrowser: function (context)
		{
			var self = $(this),
				  ui = $.summernote.ui;

			// add hello button
			context.memo('button.mediabrowser', function()
			{
				// create button
				var button = ui.button({
					contents: '<i class="fa fa-picture-o"/>',
					tooltip: 'Foto / Video',
					click: function ()
					{
						$.fancybox( 
						{
							width: '95%',
							height: '95%',
							autoSize: false,
							padding: 0,
							wrapCSS: 'fancybox-mediabrowser',
							type: 'ajax',
							href: '/api/mediabrowser?mediaType=all&multiple=false',
							helpers: {
								overlay: {
									locked: false
								}
							},
							afterShow: function()
							{
								$(this.inner).find('.mediabrowser').on('submit-media', function(e, data)
								{
									for(var i in data.items)
									{
										var $node = $( data.items[i].output );

										context.invoke('editor.insertNode', $node.get(0));
									}
								});
							}
						});
					}
				});

				return button.render();
			});
		}
	});
}));